export default __webpack_public_path__ + "static/SRUS 1130 - Product Specifications & Technical Data-370791f28a8eb51d7d28dbb00d424cdc.pdf";